module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('div', {
    staticClass: "fromclass"
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "2px solid #c8c8c8",
      "text-align": "center",
      "height": "50px",
      "margin-bottom": "10px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#58666e",
      "font-size": "28px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.exportDisable,
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.exportkcbz()
      }
    }
  }, [_vm._v("导出")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "scrollArea",
    style: (_vm.innerDialog)
  }, [_c('el-scrollbar', {
    ref: "elScrollbar",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-form', {
    staticClass: "small-space mainForm",
    attrs: {
      "inline": true,
      "model": _vm.tableQuery,
      "label-position": "right",
      "label-width": "190px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "编号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "610px",
      "margin-left": "20px"
    },
    attrs: {
      "disabled": true,
      "name": "BH",
      "autoComplete": "on",
      "maxlength": "30"
    },
    model: {
      value: (_vm.BH),
      callback: function($$v) {
        _vm.BH = $$v
      },
      expression: "BH"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态："
    }
  }, [(_vm.courseStandardState == '0') ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background-color": "#808080"
    }
  }, [_vm._v("\n                            未保存\n                        ")]) : (_vm.courseStandardState == '1') ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background-color": "#e6a23c"
    }
  }, [_vm._v("\n                            未提交\n                        ")]) : (_vm.courseStandardState == '2') ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background-color": "#409eff"
    }
  }, [_vm._v("\n                            待审核\n                        ")]) : (_vm.courseStandardState == '3') ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background-color": "#67c23a"
    }
  }, [_vm._v("\n                            审核通过\n                        ")]) : (_vm.courseStandardState == '4') ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background-color": "#f56c6c"
    }
  }, [_vm._v("\n                            审核驳回\n                        ")]) : _c('div')]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "起效学年："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "610px",
      "margin-left": "20px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择",
      "disabled": true
    },
    model: {
      value: (_vm.dqxnxq),
      callback: function($$v) {
        _vm.dqxnxq = $$v
      },
      expression: "dqxnxq"
    }
  }, _vm._l((_vm.xnxq), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适用专业"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "610px",
      "margin-left": "20px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择",
      "disabled": true,
      "filterable": ""
    },
    model: {
      value: (_vm.SYZY),
      callback: function($$v) {
        _vm.SYZY = $$v
      },
      expression: "SYZY"
    }
  }, _vm._l((_vm.zy), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "编制人"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "610px",
      "margin-left": "20px"
    },
    attrs: {
      "disabled": true,
      "name": "BZR",
      "autoComplete": "on",
      "maxlength": "30"
    },
    model: {
      value: (_vm.BZR),
      callback: function($$v) {
        _vm.BZR = $$v
      },
      expression: "BZR"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "编制日期"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "610px",
      "margin-left": "20px"
    },
    attrs: {
      "name": "BZRQ",
      "align": "right",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "format": "yyyy-MM-dd HH:mm",
      "type": "datetime",
      "placeholder": "日期"
    },
    model: {
      value: (_vm.BZRQ),
      callback: function($$v) {
        _vm.BZRQ = $$v
      },
      expression: "BZRQ"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "1340px",
      "margin-left": "20px"
    },
    attrs: {
      "disabled": true,
      "name": "KC",
      "autoComplete": "on",
      "maxlength": "30"
    },
    model: {
      value: (_vm.KC),
      callback: function($$v) {
        _vm.KC = $$v
      },
      expression: "KC"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.historyDisable
    },
    on: {
      "click": function($event) {
        return _vm.findwnkcbz()
      }
    }
  }, [_vm._v("往年课程标准")])], 1), _vm._v(" "), _c('div', {
    staticClass: "fromtitle new1"
  }, [_vm._v("课程性质")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "id": "KCXZ",
      "type": "textarea",
      "name": "KCXZ",
      "rows": "3"
    },
    model: {
      value: (_vm.KCXZ),
      callback: function($$v) {
        _vm.KCXZ = $$v
      },
      expression: "KCXZ"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fromtitle new1"
  }, [_vm._v("设计思路")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "id": "SJSL",
      "type": "textarea",
      "name": "SJSL",
      "rows": "3"
    },
    model: {
      value: (_vm.SJSL),
      callback: function($$v) {
        _vm.SJSL = $$v
      },
      expression: "SJSL"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fromtitle new1"
  }, [_vm._v("课程目标")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "KCMB",
      "type": "textarea",
      "name": "KCMB",
      "rows": "3"
    },
    model: {
      value: (_vm.KCMB),
      callback: function($$v) {
        _vm.KCMB = $$v
      },
      expression: "KCMB"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.operateDisable
    },
    on: {
      "click": function($event) {
        return _vm.addZsdlog()
      }
    }
  }, [_vm._v("新建知识点或技能点")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "disabled": _vm.operateDisable || _vm.addsj
    },
    on: {
      "click": function($event) {
        return _vm.editZsdlog()
      }
    }
  }, [_vm._v("编辑知识点或技能点")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.operateDisable || _vm.addsj
    },
    on: {
      "click": function($event) {
        return _vm.deletezsd()
      }
    }
  }, [_vm._v("删除知识点或技能点")])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%",
      "max-height": "600px"
    },
    attrs: {
      "data": _vm.tableData,
      "cell-style": _vm.handleCellStyle,
      "span-method": _vm.objectSpanMethod,
      "stripe": "",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "height": "600px",
      "header-cell-style": {
        'font-weight': '900',
        'color': '#58666e'
      }
    },
    on: {
      "cell-click": _vm.handleCellClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": '工作任务 \n 一级知识点技能点',
      "prop": "job",
      "align": "center",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '参考学时',
      "prop": "time",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '技能与学习水平 \n 二级技能点',
      "prop": "skill",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '技能与学习水平 \n 三级技能点',
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-table', {
          attrs: {
            "data": props.row.slevellist,
            "show-header": false,
            "align": "center",
            "stripe": ""
          },
          on: {
            "cell-click": _vm.onsanjiRowClick
          }
        }, [_c('el-table-column', {
          attrs: {
            "align": "center",
            "prop": "kk_mc"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '知识与学习水平 \n 二级知识点',
      "prop": "knowlage",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '知识与学习水平 \n 三级知识点',
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-table', {
          attrs: {
            "data": props.row.klevellist,
            "show-header": false,
            "align": "center",
            "stripe": ""
          },
          on: {
            "cell-click": _vm.onsanjiRowClick
          }
        }, [_c('el-table-column', {
          attrs: {
            "align": "center",
            "prop": "kk_mc"
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "height": "90px",
      "margin-top": "25px"
    },
    attrs: {
      "label": "总课时"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "1000px"
    },
    attrs: {
      "disabled": true,
      "name": "ZKS",
      "autoComplete": "on",
      "maxlength": "10"
    },
    model: {
      value: (_vm.ZKS),
      callback: function($$v) {
        _vm.ZKS = $$v
      },
      expression: "ZKS"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fromtitle new1"
  }, [_vm._v("教学活动参考")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "id": "JXHDCK",
      "type": "textarea",
      "name": "JXHDCK",
      "rows": "3"
    },
    model: {
      value: (_vm.JXHDCK),
      callback: function($$v) {
        _vm.JXHDCK = $$v
      },
      expression: "JXHDCK"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程总学时"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "1000px"
    },
    attrs: {
      "name": "KCZXS",
      "autoComplete": "on",
      "maxlength": "30"
    },
    model: {
      value: (_vm.KCZXS),
      callback: function($$v) {
        _vm.KCZXS = $$v
      },
      expression: "KCZXS"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zxstsy"
  }, [_vm._v(_vm._s(_vm.zxsts))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "fromtitle new1"
  }, [_vm._v("课程标准原件")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.updateTipsVisible),
      expression: "updateTipsVisible"
    }],
    staticClass: "uploadTips"
  }, [_vm._v("第一次保存之后才可上传课程标准原件")]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.updateTipsVisible),
      expression: "!updateTipsVisible"
    }],
    attrs: {
      "span": 3
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "action": _vm.uploadUrl,
      "limit": 1,
      "data": {
        kk_kcbzbh: this.BH
      },
      "disabled": _vm.uploadDisable,
      "show-file-list": false,
      "on-error": _vm.uploadError,
      "on-success": _vm.uploadSuccess,
      "on-remove": _vm.deleteFile,
      "auto-upload": true
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "success",
      "disabled": _vm.uploadDisable
    },
    slot: "trigger"
  }, [_vm._v("上传")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.download.apply(null, arguments)
      }
    }
  }, [_vm._v("下载")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger",
      "disabled": _vm.uploadDisable
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.deleteFile.apply(null, arguments)
      }
    }
  }, [_vm._v("删除")])], 1), _vm._v(" "), _c('div', {
    staticClass: "fileName"
  }, [_vm._v(_vm._s(_vm.filename))])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "inputBox"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.operateDisable,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveMsg()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.operateDisable,
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.tjMsg()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.auditDisable,
      "type": "danger"
    },
    on: {
      "click": _vm.showAuditDialog
    }
  }, [_vm._v("审核")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "yropen3",
    staticStyle: {
      "width": "100%",
      "overflow-y": "auto",
      "top": "100px"
    },
    attrs: {
      "id": "wndrDialog",
      "title": '往年课程标准',
      "visible": _vm.historyVisible,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.historyVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "name": "wnkcbzbh",
      "placeholder": "往年课程标准编号",
      "maxlength": "30"
    },
    model: {
      value: (_vm.wnkcbzbh),
      callback: function($$v) {
        _vm.wnkcbzbh = $$v
      },
      expression: "wnkcbzbh"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "name": "wnkcbzbh",
      "placeholder": "往年课程标准名称",
      "maxlength": "30"
    },
    model: {
      value: (_vm.wnkcmc),
      callback: function($$v) {
        _vm.wnkcmc = $$v
      },
      expression: "wnkcmc"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.findwnkcbz
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    ref: "multipleTable2",
    attrs: {
      "data": _vm.wnkcbz,
      "stripe": "",
      "border": "",
      "fit": "",
      "max-height": "650",
      "element-loading-text": "信息加载中",
      "highlight-current-row": "",
      "height": "450"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "编号",
      "prop": "kk_kcbzbh",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程",
      "prop": "kcmc",
      "align": "center",
      "width": "270"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "起效学年",
      "prop": "xqmc",
      "align": "center",
      "width": "220"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "编制人",
      "prop": "jsmc",
      "align": "center",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "prop": "knowlage",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.CKKCBZ(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-tickets"
        }), _vm._v(" 查看\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "disabled": _vm.operateDisable,
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.importmsg(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-document-copy"
        }), _vm._v(" 导入\n                    ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "line-height": "60px",
      "color": "blue",
      "font-size": "18px",
      "text-align": "center"
    }
  }, [_vm._v("导入课程时仅覆盖：课程目标、课程内容与要求及教学活动参考的内容")])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "openBoxOpenBox",
    attrs: {
      "title": "新增工作任务",
      "visible": _vm.addZsd,
      "top": "300px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.addZsd = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_vm._v("工作任务名称：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.addjobgzrw),
      callback: function($$v) {
        _vm.addjobgzrw = $$v
      },
      expression: "addjobgzrw"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_vm._v("参考学时：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.addjobckxs),
      callback: function($$v) {
        _vm.addjobckxs = $$v
      },
      expression: "addjobckxs"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.savejz,
      "type": "primary"
    },
    on: {
      "click": _vm.addjobzsdsave
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.addZsd = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "openBoxOpenBox",
    attrs: {
      "title": "编辑工作任务",
      "visible": _vm.editZsd,
      "top": "300px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.editZsd = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_vm._v("工作任务名称：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.editjobgzrw),
      callback: function($$v) {
        _vm.editjobgzrw = $$v
      },
      expression: "editjobgzrw"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_vm._v("参考学时：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.editjobckxs),
      callback: function($$v) {
        _vm.editjobckxs = $$v
      },
      expression: "editjobckxs"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.savejz,
      "type": "primary"
    },
    on: {
      "click": _vm.editjobzsdsave
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.editZsd = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "openBoxOpenBox",
    attrs: {
      "title": "新增二级技能点或知识点",
      "visible": _vm.addejZsd,
      "top": "300px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.addejZsd = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_vm._v("所属工作任务：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": true,
      "type": "text"
    },
    model: {
      value: (_vm.addjobgzrw),
      callback: function($$v) {
        _vm.addjobgzrw = $$v
      },
      expression: "addjobgzrw"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_vm._v("二级技能点名称：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "blur": _vm.selectBlur
    },
    model: {
      value: (_vm.ejskill),
      callback: function($$v) {
        _vm.ejskill = $$v
      },
      expression: "ejskill"
    }
  }, _vm._l((_vm.ejskilllist), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.kk_mc,
        "value": item.kk_zycsbh
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_vm._v("二级知识点名称：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "blur": _vm.selectBlur1
    },
    model: {
      value: (_vm.ejknowlage),
      callback: function($$v) {
        _vm.ejknowlage = $$v
      },
      expression: "ejknowlage"
    }
  }, _vm._l((_vm.ejknowlagelist), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.kk_mc,
        "value": item.kk_zycsbh
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.savejz,
      "type": "primary"
    },
    on: {
      "click": _vm.addejzsdsave
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.addejZsd = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "openBoxOpenBox",
    attrs: {
      "title": "编辑二级技能点或知识点",
      "visible": _vm.editejZsd,
      "top": "300px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.editejZsd = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_vm._v("所属工作任务：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.ejdisabled,
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "blur": _vm.selectBlur
    },
    model: {
      value: (_vm.yjeditzsd),
      callback: function($$v) {
        _vm.yjeditzsd = $$v
      },
      expression: "yjeditzsd"
    }
  }, _vm._l((_vm.yjlist), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.kk_mc,
        "value": item.kk_zycsbh
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_vm._v("二级技能点名称：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "blur": _vm.selectBlur4
    },
    model: {
      value: (_vm.ejeditskill),
      callback: function($$v) {
        _vm.ejeditskill = $$v
      },
      expression: "ejeditskill"
    }
  }, _vm._l((_vm.ejskilllist), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.kk_mc,
        "value": item.kk_zycsbh
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_vm._v("二级知识点名称：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "blur": _vm.selectBlur5
    },
    model: {
      value: (_vm.ejeditknowlage),
      callback: function($$v) {
        _vm.ejeditknowlage = $$v
      },
      expression: "ejeditknowlage"
    }
  }, _vm._l((_vm.ejknowlagelist), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.kk_mc,
        "value": item.kk_zycsbh
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.savejz,
      "type": "primary"
    },
    on: {
      "click": _vm.editejzsdsave
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.editejZsd = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "openBoxOpenBox",
    attrs: {
      "title": _vm.sjadddialogtitle,
      "visible": _vm.addsjZsdjnd,
      "top": "300px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.addsjZsdjnd = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_vm._v("所属二级" + _vm._s(_vm.sjadddialogstr) + "点：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": true,
      "type": "text"
    },
    model: {
      value: (_vm.ssejmc),
      callback: function($$v) {
        _vm.ssejmc = $$v
      },
      expression: "ssejmc"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_vm._v("三级" + _vm._s(_vm.sjadddialogstr) + "点名称：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "blur": _vm.selectBlur2
    },
    model: {
      value: (_vm.sjzsdjnd),
      callback: function($$v) {
        _vm.sjzsdjnd = $$v
      },
      expression: "sjzsdjnd"
    }
  }, _vm._l((_vm.sjzsdjndlist), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.kk_mc,
        "value": item.kk_zycsbh
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.savejz,
      "type": "primary"
    },
    on: {
      "click": _vm.addsjzsdsave
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.addsjZsdjnd = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "openBoxOpenBox",
    attrs: {
      "id": "addzsd",
      "title": _vm.sjeditdialogtitle,
      "visible": _vm.editsjZsdjnd,
      "top": "300px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.editsjZsdjnd = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_vm._v("所属二级" + _vm._s(_vm.sjeditdialogstr) + "点：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.sjdiassej),
      callback: function($$v) {
        _vm.sjdiassej = $$v
      },
      expression: "sjdiassej"
    }
  }, _vm._l((_vm.sjssejzsdlist), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.kk_mc,
        "value": item.kk_zycsbh
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_vm._v("三级" + _vm._s(_vm.sjeditdialogstr) + "点名称：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "blur": _vm.selectBlur3
    },
    model: {
      value: (_vm.editsjzsdjnd),
      callback: function($$v) {
        _vm.editsjzsdjnd = $$v
      },
      expression: "editsjzsdjnd"
    }
  }, _vm._l((_vm.sjzsdjndlist), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.kk_mc,
        "value": item.kk_zycsbh
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.savejz,
      "type": "primary"
    },
    on: {
      "click": _vm.editsjzsdsave
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.editsjZsdjnd = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "yropen3",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "id": "ckkcbz",
      "title": "查看-课程标准",
      "width": "98%",
      "visible": _vm.CKKBShow,
      "fullscreen": true,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.CKKBShow = $event
      }
    }
  }, [(_vm.CKKBShow) ? _c('criterionforcurriculumshow', {
    attrs: {
      "KBBH": _vm.CKKBBH
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.auditDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "审核",
      "visible": _vm.auditDialogVisible,
      "width": "900px",
      "top": "300px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.auditDialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('audit', {
    ref: "audit",
    attrs: {
      "itemCode": _vm.courseStandardInfo.auditParam,
      "relatedCode": _vm.courseStandardInfo.id,
      "auditLevel": _vm.courseStandardInfo.auditLevel
    },
    on: {
      "auditCallback": _vm.auditCallback
    }
  })], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df6a4cde"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/teachingManage/courseStandard/criterion_for_curriculum.vue
// module id = 1906
// module chunks = 502